import { Box, Card, Grid, Paper, styled } from '@mui/material';
import L from 'leaflet';

export const PageHeader = styled(Box)`
    background-image: url('/images/header-background.svg');
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
    min-height: 60px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: white;
    width: 100%;
`;

export const Greeter = styled(Box)`
    color: white;
    display: flex;
    align-items: center;
`;

export const StyledGrid = styled(Grid)`
    border: 1px solid #ccc;
    border-radius: 8px;
    background-color: #fff;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
`;

export const StyledMainPaper = styled(Paper)`
    height: calc(100vh - 150px);
    max-height: 100vh;
    padding: 0;
    margin: 0;
    width: 100%;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.3);
`;

export const StyledDetailsCard = styled(Card)`
    height: fit-content;
    width: 100%;
    flex-direction: column;
    display: flex;
    box-shadow: none;
    overeflow: auto;
`;

export const StyledDateRangeCard = styled(Card)`
    height: fit-content;
    width: auto;
    display: flex;
    box-shadow: none;
    justify-content: center;
    padding: 0 10px;
    margin: 20px 0 20px 0;
`;

export const MakeColorIcon = (color: string, borderColor: string, passenger: number) => {
    const svg = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 61 85"><defs><style>.fa-secondary{opacity:.9;}</style></defs><path fill="${color}" stroke="${borderColor}" stroke-width="5"  d="M31.688,2C47.428,2,59,13.989,59,29.729v0.896C59,51.367,41.119,77,31.212,83h-0.237C21.069,77,2,51.367,2,30.625v-0.896C2,13.989,14.76,2,30.5,2C30.659,2,31.529,2,31.688,2z"></path><text  x="50%" y="50%" dy=".13em" font-size="40" font-weight="bold" text-anchor="middle" fill="#FFF">${passenger}</text></svg>`;
    return L.divIcon({
        className: 'custom-div-icon',
        html: `<div style="filter: drop-shadow(1px 1px 2px ${color});">${svg}</div>`,
        iconSize: [25, 10],
        iconAnchor: [15, 40],
        popupAnchor: [-2, -40],
    });
};

export const FactoryIcon = (color: string) => {
    const svg = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="${color}" d="M335.2 244.7c.5 3.7 .8 7.5 .8 11.3c0 44.2-35.8 80-80 80s-80-35.8-80-80s35.8-80 80-80c3.8 0 7.6 .3 11.3 .8l31.2-31.2L293.7 117c-12-3.3-24.7-5-37.7-5c-79.5 0-144 64.5-144 144s64.5 144 144 144s144-64.5 144-144c0-13.1-1.7-25.7-5-37.7l-28.6-4.8-31.2 31.2zm110.1-20.8c1.8 10.4 2.7 21.1 2.7 32.1c0 106-86 192-192 192S64 362 64 256S150 64 256 64c10.9 0 21.6 .9 32.1 2.7l9.3-9.3 43.1-43.1C314 5 285.6 0 256 0C114.6 0 0 114.6 0 256S114.6 512 256 512s256-114.6 256-256c0-29.6-5-58-14.3-84.5l-43.1 43.1-9.3 9.3zm-80.2-43.1l50.7 8.4c10.2 1.7 20.6-1.6 27.9-8.9l51.2-51.2c8.1-8.1 5.3-21.9-5.4-26.2L432 80 409 22.5c-4.3-10.7-18-13.5-26.2-5.4L331.6 68.4c-7.3 7.3-10.6 17.7-8.9 27.9l8.4 50.7L239 239c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l92.1-92.1z"/></svg>`;
    return L.divIcon({
        className: 'custom-div-icon',
        html: `<div style="background-color: white; border-radius: 50px">${svg}</div>`,
        iconSize: [30, 10],
        iconAnchor: [15, 20],
        popupAnchor: [0, -20],
    });
};